var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isActiveObfuscatedLink)?_c('div',{ref:"icd",staticClass:"icd",attrs:{"data-icd":_vm.generateDataIcd(_vm.link)},on:{"click":function($event){return _vm.decryptsAndUsesTheLink($event)}}},[_vm._t("default")],2):_c('a',{staticClass:"icd",attrs:{"href":_vm.link}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }